import * as React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Button } from '@acceligentllc/storybook';

import CustomModal from 'af-components/CustomModal';
import PdfDocument from 'af-components/DocumentViewer/PdfDocument';

import * as CompanyActions from 'af-actions/companies';

import styles from './styles.module.scss';

interface OwnProps {
	showModal: boolean;
	closeModal: () => void;
}

type Props = OwnProps & ConnectedProps<typeof connector>;

const CompanyPolicyModal: React.FC<Props> = (props: Props) => {
	const {
		closeModal,
		showModal,
		findCompanyPolicy,
	} = props;

	const [pdfSource, setPdfSource] = React.useState<Nullable<ArrayBuffer>>(null);
	const [isLoaded, setIsLoaded] = React.useState(false);

	const fetchCompanyPolicy = React.useCallback(async () => {
		const companyPolicy = await findCompanyPolicy();
		if (companyPolicy.buffer) {
			setPdfSource(companyPolicy.buffer.data);
		}
		setIsLoaded(true);
	}, [findCompanyPolicy]);

	React.useEffect(() => {
		if (showModal) {
			fetchCompanyPolicy();
		}
	}, [fetchCompanyPolicy, showModal]);

	const handleCloseModal = React.useCallback(() => {
		setPdfSource(null);
		setIsLoaded(false);
		closeModal();
	}, [closeModal]);

	const hasNoPdfToShow = isLoaded && !pdfSource;

	return (
		<CustomModal
			closeModal={handleCloseModal}
			modalStyle="info"
			showModal={showModal}
			size="lg"
		>
			<CustomModal.Header
				closeModal={handleCloseModal}
				title="Company Rest Break Policy"
			/>
			<CustomModal.Body>
				{pdfSource &&
					<div className={styles.pdf}>
						<PdfDocument
							data={pdfSource}
							pageLoading={''}
							scale={1.2}
						/>
					</div>
				}
				{hasNoPdfToShow && <span>No company policy to show</span>}
			</CustomModal.Body>
			<CustomModal.Footer>
				<Button
					label="OK"
					onClick={handleCloseModal}
					style="secondary"
				/>
			</CustomModal.Footer>
		</CustomModal>
	);
};

function mapDispatchToProps() {
	return {
		findCompanyPolicy: CompanyActions.findCompanyPolicy,
	};
}

const connector = connect(null, mapDispatchToProps());

const enhance = compose<React.ComponentClass<OwnProps>>(
	React.memo,
	connector
);

export default enhance(CompanyPolicyModal);
